export default __webpack_public_path__ + "static/media/12pcLoader.df0babb0.gif";